/* eslint-disable react/display-name */
/**
 *
 * FormularioPreguntas
 *
 */

import { memo } from 'react';

import { lazyLoad } from 'utils/loadable';

import { CollectionsRouting } from './collections.routing';
interface Props {}

export const CollectionsComponent = memo((props: Props) => {
  return (
    <>
      <CollectionsRouting />
    </>
  );
});

export const CollectionsModule = lazyLoad(
  () => import('./collections.module'),
  (module) => module.CollectionsComponent
);
